<template>
  <div class="app-main">
    <!-- //通过v-if来动态的判断展示 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <transition :name="transitionName" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      transitionName: "transitionRouterRight",
    };
  },
  created() {},
  methods: {},
  computed: {},
  watch: {
    $route(to, from) {
      if (to.fullPath != from.fullPath) {
        this.transitionName = "transitionRouterRight";
      }
    },
  },
};
</script>

<style scoped>
/* @import "~@/assets/css/transition.css"; */
.app-main {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.commontab {
  width: 100%;
  background-color: #fafafa;
  border-bottom: 1px solid #ddd;
}
.transitionRouterRight-enter-active,
.transitionRouterRight-leave-active {
  transition: all 0.5s;
  position: relative;
}
.transitionRouterRight-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.transitionRouterRight-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
</style>
